export const formatDate = new Intl.DateTimeFormat('nl-BE', {
  weekday: 'long',
  month: 'long',
  day: 'numeric',
})

export const shortDate = new Intl.DateTimeFormat('nl-BE', {
  month: 'short',
  day: 'numeric',
})
